const PREFIX_KEY = "my-apartment";
const getter = (key) => {
  if (!key)
    throw new Error(
      "'getItem' function in 'useStorage' hook must contain a valid key"
    );
  const json = localStorage.getItem(PREFIX_KEY + key);
  return JSON.parse(json);
};
const setter = (key, value) => {
  if (!key)
    throw new Error(
      "'setItem' function in 'useStorage' hook must contain a valid key"
    );
  const toJson = JSON.stringify(value);
  localStorage.setItem(PREFIX_KEY + key, toJson);
};
export const useStorage = () => {
  return {
    getItem: getter,
    setItem: setter,
  };
};

export default useStorage;
